import { PropsWithChildren } from 'react';

import styled from '@emotion/styled';

type OverlayProps = {
  isEmpty: boolean;
  emptyView: JSX.Element;
};
export const Overlay = ({ children, isEmpty, emptyView }: PropsWithChildren<OverlayProps>) => {
  return (
    <SOverlayWrapper>
      <div>{children}</div>
      {isEmpty && <SOverlayContainer>{emptyView}</SOverlayContainer>}
    </SOverlayWrapper>
  );
};

const SOverlayWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SOverlayContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;
